module.exports = __webpack_public_path__ + "public/img/cert_bg.7097e0e9.png";